import { idURL } from 'endpoints';
import umbrella from '@nackle/umbrella';
const auth = umbrella.getAuth( true, 60, 59, 
    { authority: idURL, extraQueryParams: { source: window.location.href } } );

export default auth;

export function hasPermission( permission, authProps ) {

    const [ app, key ] = permission.split( '.', 2 );
    const userPermissions = authProps?.state?.claims?.permissions;

    if ( !userPermissions ) {
        return false;
    }

    const appPermissions = userPermissions[ app ];

    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }

    return appPermissions.includes( key );
}

export const PERMISSIONS = {
    EDIT_PERSON_ATTRIBUTES: 'roster-studio.edit-person-attributes',
    READ_PERSON_ATTRIBUTES: 'roster-studio.read-person-attributes',
    READ_PERSON_CONTACT: 'roster-studio.read-person-contact',
    EDIT_PERSON_CONTACT: 'roster-studio.edit-person-contact',
    EDIT_PERSON_EMPLOYMENT: 'roster-studio.edit-person-employment',
    READ_PERSON_EMPLOYMENT: 'roster-studio.read-person-employment',
    READ_PERSON_HIERARCHY: 'roster-studio.read-person-hierarchy',
    EDIT_PERSON_HIERARCHY: 'roster-studio.edit-person-hierarchy',
    READ_PERSON_IDENTITY: 'roster-studio.read-person-identity',
    EDIT_PERSON_IDENTITY: 'roster-studio.edit-person-identity',
    READ_PERSON_PREFERENCES: 'roster-studio.read-person-preferences',
    EDIT_PERSON_PREFERENCES: 'roster-studio.edit-person-preferences',
    EDIT_PERSON_RECOVERY: 'roster-studio.edit-person-recovery',
    READ_PERSON_RECOVERY: 'roster-studio.read-person-recovery',
    READ_HIERARCHIES: 'roster-studio.read-hierarchies',
    EDIT_HIERARCHIES: 'roster-studio.edit-hierarchies',
    ROSTER_LAUNCH_AS: 'roster-studio.roster-launch-as',
    EDIT_ATTRIBUTES_IDENTIFIERS: 'roster-studio.edit-attributes-identifiers',
    READ_ATTRIBUTES_IDENTIFIERS: 'roster-studio.read-attributes-identifiers',
    READ_ROSTER_GROUP_FILE_LOAD: 'roster-studio.read-roster-group-file-load',
    EDIT_ROSTER_GROUP_FILE_LOAD: 'roster-studio.edit-roster-group-file-load'
};

export function authRequestMiddleware( url, options = {} ) {
    if ( !auth || !auth.state || !auth.state.access_token ) {
        return;
    }

    options.headers = {
        ...( options.headers || {} ),
        'authorization': `Bearer ${ auth.state.access_token }`,
        'company-id': auth.state.claims.company_id
    };
}

export function authRouteMiddleware( action, nextRoute, prevRoute ) {
    // we aren't signed in yet, so continue
    if ( !auth.state.access_token ) {
        return action.ok();
    }

    const nextCompanyId = nextRoute?.state?.params?.companyId;
    // if the next companyId is the same as the last companyId, continue
    if ( !nextCompanyId || nextCompanyId === auth.state.claims.company_id ) {
        return action.ok();
    }
    // switch to the new company
    auth.delegate( nextCompanyId ).then( () => {
        action.ok();
    } ).catch( error => {
        console.error( error );
    } );
}
